<template>
  <el-card class="m-b-1" style="margin-bottom:20px;">
    <div class="card-header">
      <h4 class="title" style="padding-bottom:10px;">
        Customer Orders and Notes
        <button
          class="btn btn-primary pull-right btn-fill"
          @click="createOrder()"
        >
          Create New Order
        </button>
      </h4>
    </div>
    <div class="card-content">
      <el-tabs @tab-click="handleTabChange" type="border-card" style="box-shadow:none;">
        <el-tab-pane>
          <span slot="label"><i class="el-icon-document"></i> Notes</span>
          <div class="col-xs-12">
            <!-- <vue-editor v-model="newNote" :editorToolbar="customToolbar" :editorOptions="editorSettings"></vue-editor> -->
            <!-- <wysiwyg v-model="newNote" /> -->
            <VuePellEditor
              v-model="newNote"
              :style-with-css="false"
              default-paragraph-separator="p"
            />
            <br />
            <button
              type="button"
              class="btn btn-wd btn-primary"
              @click="saveNote"
            >
              <span class="btn-label"><i class="fa fa-plus"></i></span>
              Add Note
            </button>

            <br />
            <br />
            <hr />
          </div>

          <div v-for="(note, index) in customer.notes" :key="index">
            <div class="col-sm-12">
              <div
                class="btn btn-danger btn-sm btn-ws pull-right"
                @click="deleteNote(note.id)"
              >
                <i class="fa fa-close"></i>
              </div>
              <div v-html="note.detail">{{ note.detail }}</div>
              <br />
              <H6 class="text-muted" style="font-weight: 400;">
                <div v-if="note.user" class="user-photo" style="table-cell;vertical-align: middle">
                    <img v-if="note.user.avatar" :src="note.user.avatar"/>
                   <img v-else src="../../../../static/img/faces/face-0.jpg" width="10"/> 
                 </div>
                <span class="text-danger">{{ note.createdBy }}</span> -
                {{ note.dateCreated | moment("DD/MM/YYYY, h:mm:ss a") }}
              </H6>
              <hr />
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane>
          <span slot="label"><i class="el-icon-goods"></i> Orders</span>
          <div class="col-xs-12">
            <order-list
              v-if="customer.orders"
              :orders="customer.orders"
            ></order-list>
            <div v-else>No Current Orders</div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </el-card>
</template>

<script>
//import api from "../api";
//import complexapi from '../../../api/complexApi'
import gql from "graphql-tag";
import OrderList from "./OrderList";
import { mapGetters } from "vuex";
import { VueTabs } from "vue-nav-tabs";
import { VueEditor } from "vue2-editor";
import VuePellEditor from "vue-pell-editor";
import moment from "moment";

export default {
  components: {
    OrderList,
    VueTabs,
    VueEditor,
    VuePellEditor,
  },
  props: ["id", "customer"],
  data() {
    return {
      customToolbar: [
        [{ size: ["small", false, "large", "huge"] }],
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" },
        ],
        ["link", "image"],
        ["clean"],
      ],
      editorSettings: {
        bounds: "#quill-container",
      },
      notes: [],
      newNote: "",
      orders: [],
      customerID: "",
    };
  },
  computed: {
    ...mapGetters(["getCustomer"]),

    user() {
      const token = localStorage.getItem("vuex");
      const parsed = JSON.parse(token);
      return parsed["auth"];
    },
  },

  methods: {
    handleTabChange(tab, event) {
      console.log("Getting " + tab.label);
      //console.log("getCustomer ", this.getCustomer);
      if (tab.label === "Bookings") {
        //  this.getCustomerOrders();
      }
      if (tab.label === "Notes") {
        // this.getCustomerNotes();
      }
    },

    saveNote() {
      this.newNote = this.stripHTML();
      let q = gql`
     mutation AddNote {
        insert_Note(objects: {customerId: ${this.customer.id}, detail: "${
        this.newNote
      }", createdBy: "${this.user.email}",dateCreated:"${moment().format(
        "YYYY-MM-DDTHH:mm:ss"
      )}"}) {
          returning {
            id
            detail,
            createdBy,
            dateCreated
          }
        }
      } `;
      this.$apollo
        .mutate({
          mutation: q,
        })
        .then((result) => {
          console.log(result);
          this.customer.notes.unshift(result.data.insert_Note.returning[0]);
          this.$notify({
            title: "Updated",
            message: "Note Saved",
            type: "success",
          });
        });
    },
    createOrder() {
      this.$router.push({
        path: "/order/create/?customer_id=" + this.customer.id,
      });
    },
    deleteNote(id) {
      let q = gql`
        mutation MyMutation {
          __typename
          delete_Note(where: {id: {_eq: ${id}}}) {
            affected_rows
          }
        }
      `;
      this.$apollo
        .mutate({
          mutation: q,
        })
        .then((result) => {
          this.customer.notes = _.reject(this.customer.notes, (o) => {
            return o.id == id;
          });
          this.$notify({
            title: "Updated",
            message: "Note Deleted",
            type: "success",
          });
        });
    },
    stripHTML() {
      const text = this.newNote;
      var pastedData = text.replace(/(<([^>]+)>)/gi, ""); // remove all html except the listed tags

      let wrapper = document.createElement("div");
      wrapper.innerHTML = pastedData;

      var sanitised = wrapper.textContent || wrapper.innerText;
      this.newNote = sanitised;

      return this.newNote;
    },
  },

  mounted() {},

  watch: {
    "$route.params.id": function (id) {
      this.customerID = id;
    },
  },
};
</script>
<style>
.user-photo{ 
    width: 34px;
    height: 34px;
    overflow: hidden;
   display: inline-block;   
    margin-right: 2px;
  border:2px solid rgba(0, 0, 0, 0.15);
    border-radius: 50%;
    margin-left: 2px;
}
.user-photo img{
  width: 100%;
vertical-align: middle;
border:0
}
.vue-tabs .tab-content {
  text-align: left !important;
}
.vue-tabs .tab-content {
  text-align: left !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Customers/CustomerProfile/CustomerOrderInfo.vue